/** First Recharge (FRC) subscription amount in INR. */
export const FRC_SUBSCRIPTION_AMOUNT = 1400;

function parseMoney(value) {
  if (value == null || value === "") return NaN;
  const n = Number(String(value).replace(/,/g, ""));
  return Number.isFinite(n) ? n : NaN;
}

export function isFirstRechargePlan(plan) {
  if (!plan) return false;

  const name = String(plan.name || "").toLowerCase();
  const slug = String(plan.slug || plan.code || plan.plan_code || "").toLowerCase();
  const tag = String(plan.tag || "").toLowerCase();

  return (
    name.includes("first recharge") ||
    name.includes("frc") ||
    slug === "frc" ||
    slug.includes("first_recharge") ||
    slug.includes("first-recharge") ||
    tag.includes("frc") ||
    tag.includes("first recharge")
  );
}

export function normalizeSubscriptionPlan(plan) {
  if (!isFirstRechargePlan(plan)) {
    return plan;
  }

  const durationYears = Number(plan.duration_years) > 0 ? Number(plan.duration_years) : 1;
  const originalPrice = parseMoney(plan.original_price);
  const perYearPrice = Math.round(FRC_SUBSCRIPTION_AMOUNT / durationYears);

  return {
    ...plan,
    discounted_price: FRC_SUBSCRIPTION_AMOUNT,
    per_year_price: perYearPrice,
    original_price:
      Number.isFinite(originalPrice) && originalPrice > FRC_SUBSCRIPTION_AMOUNT
        ? originalPrice
        : plan.original_price,
  };
}

export function normalizeSubscriptionPlans(plans) {
  if (!Array.isArray(plans)) return [];
  return plans.map(normalizeSubscriptionPlan);
}
